import React, { useState, useEffect } from "react";
import DashboardLayout from "../Dashboard/layout";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import axios from "axios";
import Swal from "sweetalert2";
import { FaSearch , FaAngleDoubleLeft , FaAngleDoubleRight } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
//import { IoMdDoneAll } from "react-icons/io";


const ViewRegList = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRole, setSelectedRole] = useState("");
  //const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedVerification, setSelectedVerification] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(10);
  // const [blockReason, setBlockReason] = useState('');
  // const [selectedUserId, setSelectedUserId] = useState(null);
  //const [verificationAttempts, setVerificationAttempts] = useState({}); // Add state for verification attempts
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/admin/getAlluser`
        );
        const data = await response.json();
        if (data.status === 1) {
          setUsers(data.users);
          setFilteredUsers(data.users);
        } else {
          console.error("Failed to fetch users:", data.message);
        }
      } catch (error) {
        console.error("Failed to fetch users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    let filtered = users;

    if (selectedRole) {
      filtered = filtered.filter(
        (user) => user.userType === parseInt(selectedRole)
      );
    }

    // if (selectedStatus) {
    //   filtered = filtered.filter(
    //     (user) => user.isActive === parseInt(selectedStatus)
    //   );
    // }

    if (selectedVerification) {
      filtered = filtered.filter(
        (user) => user.emailDomainVerified === parseInt(selectedVerification)
      );
    }

    if (searchQuery) {
      filtered = filtered.filter((user) => {
        const fullName = user.fullName ? user.fullName.toLowerCase() : "";
        const email = user.email ? user.email.toLowerCase() : "";
        return (
          fullName.includes(searchQuery.toLowerCase()) ||
          email.includes(searchQuery.toLowerCase())
        );
      });
    }

    setFilteredUsers(filtered);
    setCurrentPage(1);
  }, [selectedRole, searchQuery, selectedVerification, users]);

  const handleStatusChange = async (userId, newStatus) => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("newStatus", newStatus);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/admin/update-status`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.status === 1) {
        setUsers(
          users.map((user) =>
            user._id === userId ? { ...user, isActive: newStatus } : user
          )
        );
      } else {
        console.error("Failed to update status:", res.data.message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };


  const handleDeleteUser = async (cognitoUserId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this user!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/admin/deleteUser/${cognitoUserId}`,
            {
              method: "DELETE",
            }
          );

          const data = await response.json();
          if (data.status === 1) {
            setUsers(users.filter((user) => user.cognitoUserId !== cognitoUserId));
            Swal.fire("Deleted!", "The user has been deleted.", "success");
          } else {
            Swal.fire("Error", data.message, "error");
          }
        } catch (error) {
          Swal.fire(
            "Error",
            "Failed to delete user. Please try again.",
            "error"
          );
        }
      }
    });
  };

    const indexOfFirstUser = (currentPage - 1) * usersPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstUser,indexOfFirstUser + usersPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const handleAddUserClick = () => {
    navigate("/add-user");
  };

  const roleOptions = [
    { value: '', label: 'All' },
    { value: '1', label: 'Mentor' },
    { value: '0', label: 'Mentee' },
  ];
  // const statusOptions = [
  //   { value: '', label: 'All' },
  //   { value: '1', label: 'Active' },
  //   { value: '0', label: 'Inactive' },
  // ];
  const verfyOptions = [
    { value: '', label: 'All' },
    { value: '1', label: 'Verified' },
    { value: '0', label: 'Unverified' },
  ];

  return (
    <>
      <DashboardLayout>

        <section className="MainDivSec">

          <Headings headspan="Registered" hedtext=" Users List " />

          <div className="TopSelctDiv">
            <div className="LeftSlct">
              <UserSelect slctvluename="Filter by Role:" selectedRole={selectedRole} slctonchange={(e) => setSelectedRole(e.target.value)} options={roleOptions} slcthtmlfor="roleFilter" />
              {/* <UserSelect slctvluename="Filter by Status:" selectedRole={selectedStatus} slctonchange={(e) => setSelectedStatus(e.target.value)} options={statusOptions} slcthtmlfor="statusFilter" /> */}
              <UserSelect slctvluename="Filter by Verification:" selectedRole={selectedVerification} slctonchange={(e) => setSelectedVerification(e.target.value)} options={verfyOptions} slcthtmlfor="vrifyFilter" />
            </div>
            <div className="RytSrch">
              <SerchInput searchvalue={searchQuery} searchonchange={(e) => setSearchQuery(e.target.value)} srchid="searchQuery" srchplcehldr="Search by name or email" />
              <ADDBTN adtext="Add User" adonclick={handleAddUserClick}/>
            </div>
          </div>


          <div className="TableSec">

            {loading ? (
              <p className="Loadingpara">Loading...</p>
            ) : (
            <>

            <div className="UserTableDiv">
              <table className="User_Table">
                <thead>
                  <tr>
                    <th>SR NO</th>
                    <th>Name</th>
                    <th>Role</th>
                    <th>Email</th>
                    <th style={{textAlign:"center"}}>Domain Status</th>
                    <th style={{textAlign:"center"}}>Verified/Unverified</th>
                    <th style={{textAlign:"center"}}>Inactive/Active</th>
                    {/* <th>Cognito Status</th> */}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.length === 0 ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center", padding: "12px", color: "#999" }}>
                        User not found
                      </td>
                    </tr>
                  ) : (
                  currentUsers.map((user, index) => (
                    <tr key={user._id}>
                     <td>{indexOfFirstUser + index + 1}</td> {/* Updated SR NO */}
                      <td>{user.fullName}</td>
                      <td>{user.userType === 1 ? "Mentor" : user.userType === 0 && user.isCreateProfile === 1 ? "Mentee" : ""}</td>
                      <td>{user.email}</td>
                      <td style={{textAlign:"center"}}>
                        {user.emailDomainVerified === 1
                          ? "Verified"
                          : user.emailDomainVerified === 0
                          ? "Unverified"
                          : "N/A"}
                      </td>
                      <td style={{textAlign:"center"}}>{user.isVerified === 1 ? "Verified" :  "Unverified"}</td>
                      <td className="Toggleactive">
                        <Form.Check
                          type="switch"
                          id={`active-switch-${user._id}`}
                          label=""
                          checked={user.isActive === 1}
                          onChange={() => {
                            const newStatus = user.isActive === 1 ? 0 : 1;
                            handleStatusChange(user._id, newStatus);
                          }}
                        />
                      </td>
                      {/* <td style={{textAlign:"center"}}>
                      <button
                          className={`verify-btn ${
                            user.isVerified === 1
                              ? "btn-verified"
                              : "btn-unverified"
                          }`}
                          onClick={() =>
                            handleVerifyUser(
                              user._id,
                              user.email,
                              user.invitationCode
                            )
                          }
                          disabled={user.isVerified === 1}
                        >
                          {user.isVerified === 1 ? <IoMdDoneAll /> : "Send OTP"}
                        </button>
                      </td> */}
                      <td style={{textAlign:"center"}}>
                        <button
                          className="delete-btn "
                          onClick={() => handleDeleteUser(user.cognitoUserId)}
                        >
                         <MdDelete />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
                </tbody>
              </table>
            </div>

            <div className="Tablepagination">
                <button onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1} >
                  <FaAngleDoubleLeft/>
                </button>
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => paginate(index + 1)}
                    className={currentPage === index + 1 ? "active" : ""}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}>
                  <FaAngleDoubleRight />
                </button>
            </div>

            </>
            )}
          </div>


        </section>

      </DashboardLayout>
    </>
  );
};

export default ViewRegList;

export function Headings({hedtext , headspan}) {
  return <div className="RegistHeading">
    <h2><span>{headspan}</span>{hedtext} </h2>
  </div>;
}

// ADDBTN
export function ADDBTN({adtext,adonclick}) {
  return <div className="AddBtn">
    <button onClick={adonclick}>
      {adtext}
    </button>
  </div>;
}
// ADDBTN

// SerchInput
export function SerchInput({searchvalue, searchonchange,srchid , srchplcehldr})  {
  return <div className="SearchDiv">
    <input
      type="text"
      id={srchid}
      value={searchvalue}
      onChange={searchonchange}
      placeholder={srchplcehldr} />
    <FaSearch />
  </div>;
}
// SerchInput

// UserSelect
export function UserSelect({ slctvluename, selectedRole, slctonchange, options , slcthtmlfor }) {
  return (
    <div className="SlectContDiv">
      <label htmlFor={slcthtmlfor}>{slctvluename}</label>
      <select id={slcthtmlfor} value={selectedRole} onChange={slctonchange}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
// UserSelect
